angular.module('bribac.views.listIbacs', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.filterUtils',
  'bribac.components.whenLoaded',
  'bribac.components.ibacDetails',
  'bribac.components.filterActive',
  'bribac.components.organizationDetails',
  'bribac.components.filterOrganization'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/ibac', {
      templateUrl: 'list-ibacs-view.html',
      controller: 'ListIbacsViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('ListIbacsViewCtrl', function(
    $scope,
    $filter,
    $timeout,
    KINDS,
    api,
    filterUtils,
    permissions
  ) {
    var $ctrl = this
    $ctrl.permissions = permissions

    $ctrl.currentPage = 1
    $ctrl.pageSize = 10
    $ctrl.total = 0

    $ctrl.filter = 'active'
    $ctrl.organization = {id: -1, name: ''}

    $scope.$watch('$ctrl.filter', getIbacs)
    $scope.$watch('$ctrl.organization', getIbacs)
    $scope.$watch("$ctrl.pageSize", getIbacs);

    $ctrl.onPageChange = function () {
      getIbacs()
    }

    // Reload list of iBacs from REST API upon change of filter, organization or pageSize value. For pageChange no param is passed.
    function getIbacs(newValue, oldValue) {
      // Check if there is coming change of $watch callback
      if (newValue !== undefined && newValue == oldValue) return
      // Reset page only if filter values change
      if (newValue && oldValue) {
        $ctrl.currentPage = 1
      }
      $ctrl.ibacsPromise = api.getView(KINDS.IBAC + '?status=' + $ctrl.filter
        + "&organizationId=" + $ctrl.organization.id + "&page=" + $ctrl.currentPage
        + "&size=" + $ctrl.pageSize).then(function (request) {
          $ctrl.ibacs = request.data.list
          $ctrl.total = request.data.total
        })
    }

    $timeout( getIbacs )
  })
